import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/notifications/peolpe`

export default async () => {
  const { data } = await http.get(`${api}`)
  return data ?? []
}
